// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import VueCookies from 'vue-cookies'
import VueMeta from 'vue-meta'

Vue.use(VueMeta)
Vue.use(Vuetify)
Vue.use(VueCookies)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  vuetify : new Vuetify({
    theme: {
      themes: {
        light: {
          // primary: process.env.NODE_ENV == 'production' ? '#00a1df' : 'black',
          // original 0c8bf3
          // yellow FE9824
          // dino blue 011135
          // rojo 862334
          primary: '#1b74e4',// '#0c8bf3',
          secondary: '#f7a501',
          accent: '#8c9eff',
          error: '#b71c1c'
        },
      },
    },
  }),
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js